export default {"src":"/_next/static/media/premiere-rencontre.84e26cf8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};